import "./PdfDetailsInformationModal.scss";
import React, { useState, useEffect, useContext, useRef } from "react";
import {
  getMLRStatus,
  updateDeckInfo,
  validateDeckName,
} from "../../../../services/apis";
import TextField from "@mui/material/TextField";
import EditName from "../../../../images/Edit_Traceability.svg";
import lockTraceability from "../../../../images/Lock-Traceability.svg";
import expiredRestrictedIcon from "../../../../images/expired-restriction-icon.svg";
import CopyLinkIcon from "../../../../images/copyLinkIcon.svg";
import CopyLinkIconDisable from "../../../../images/copyLinkIconDisable.svg";
import refreshIcon from "../../../../images/Refresh.svg";
import ValueContext from "../../../../utils/contextAPI/contextAPI";
import CircularProgressBar from "../../../../utils/CircularProgressBar";
import { convertInDate } from "../../../../utils";
// import { showErrorToast } from "../../../../toastComponent/ToastComponent";
import { WEB_URL } from "../../../../services/axiosConfig";
import { showErrorToast } from "../../../toastComponent/ToastComponent";
import { toast } from "react-toastify";

const PdfDetailsInformationModal = (props) => {
  const {
    closeCardDetailsModal,
    mode,
    cardInformation,
    deckId,
    templateType,
    detailLink,
    setCardInformation,
    nameDrop,
    countriesList,
    brands,
    setshowFetchedResults
  } = props;
  const [updateEditable, setUpdateEditable] = useState(false);
  const [nameUpdate, setNameUpdate] = useState("");
  const [updateBtnStatus, setUpdateBtnStatus] = useState(true);
  const [updatedDeckName, setUpdatedDeckName] = useState("");
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const appData = useContext(ValueContext);
  const [modifiedOn, setModifiedOn] = useState();
  const [modifiedBy, setModifiedBy] = useState();
  const [copyTitleMsg, setCopyTitleMsg] = useState("click to copy the link");
  const [latestCardInformation, setLatestCardInformation] = useState();
  const errorToastIdRef = useRef(null);
  const lastMaxLengthToastAtRef = useRef(0);

  useEffect(() => {
    setNameUpdate(cardInformation?.name ? cardInformation.name : "");
    setModifiedOn(
      cardInformation?.updated_at ? cardInformation?.updated_at : ""
    );
    setModifiedBy(
      cardInformation?.updated?.name ? cardInformation?.updated?.name : "-"
    );
    //getCurrentStatus()
  }, []);

  const getCurrentStatus = () => {
    setLoading(true);

    getMLRStatus(
      cardInformation._id,
      false,
      async (response, err, errorCode) => {
        if (err) {
          setLoading(false);
          // console.log(err);
        } else {
          setLoading(false);
          let data = await response.data.response;
          setLatestCardInformation(data);
        }
      }
    );
  };

  const updateNameHandler = async () => {
    try {
      const updateName = {
        name: nameUpdate,
      };
      setLoading(true);
      const valid = await validateDeckName(updateName, cardInformation.type);
      if (valid?.success) {
        updateDeckInfo(deckId, updateName, (response, err, errorCode) => {
          if (err) {
            if (errorCode === 400) {
              showErrorToast(err.response.data.message || "Something went wrong");
            }
            setLoading(false);
          } else {
            const updatedName = response?.data?.name;
            const updatedAt = response?.data?.updated_at;
            const updatedBy = response?.data?.updated;
            // setUpdatedDeckName(response.data.name);
            appData.setDeckId({ ...appData.deckId, name: updatedName });
            setNameUpdate(updatedName || "");
            setUpdateEditable(false);
            setUpdateBtnStatus(true);            
            setModifiedOn(updatedAt);
            setModifiedBy(
              updatedBy?.name
                ? updatedBy?.name
                : "-"
            );
            
            if (typeof setCardInformation === "function") {
              setCardInformation((prev) =>
                prev
                  ? { ...prev, name: updatedName, updated_at: updatedAt, updated: updatedBy }
                  : prev
              );
            }

            if (typeof setshowFetchedResults === "function") {
              setshowFetchedResults((prev) =>
                (prev || []).map((item) =>
                  item?._id === deckId
                    ? { ...item, name: updatedName, updated_at: updatedAt, updated: updatedBy }
                    : item
                )
              );
            }

            setLoading(false)
          }
        });
      } else {
          if (valid.err) {
              const msg = valid.err.hasOwnProperty('message') ? valid.err.message : valid.err;
              showErrorToast(msg);
          }
          
          setLoading(false);
      }
    } catch (error) {
        // console.log("throw", error);
         setLoading(false);
    }
  };

  const showBlockedErrorToast = (msg) => {
    if (errorToastIdRef.current && toast.isActive(errorToastIdRef.current)) {
      return;
    }
    errorToastIdRef.current = showErrorToast(msg);
  };

  const showMaxLengthToast = (msg) => {
    const now = Date.now();
    if (now - lastMaxLengthToastAtRef.current < 3000) return;
    lastMaxLengthToastAtRef.current = now;
    showErrorToast(msg);
  };

  const nameChangeHandler = (e, submitType) => {
    if (e.key === "Enter" && (errorToastIdRef.current && toast.isActive(errorToastIdRef.current) || loading)) {
      e.preventDefault();
      return;
    }
    let { value } = e.target;
    if (e.target.value.length > 30) {
      showMaxLengthToast("Presentation name exceeded the maximum length");
      return;
    }
    if (value.trim().toLowerCase() === "shared") {
      if (submitType === "input") {
        setNameUpdate(value);
      }
      setUpdateBtnStatus(true);
      setError(true);
      if (e.key !== "Enter") {
        return;
      }
    }
    const specialChars = /[`!@#$%^&*+\=\[\]{};':"\\|,.<>\/?~]/;
    if (specialChars.test(value) || value.includes(" ")) {
      return;
    } else {
      if (submitType === "input") {
        setNameUpdate(value);
        if (value !== "" && value.length >= 3 && value.length <= 30) {
          setUpdateBtnStatus(false);
        } else {
          setUpdateBtnStatus(true);
        }
      }
    }
    if (nameUpdate.trim().length < 3) {
      setError(true);
      return;
    }
    if (submitType === "blur" || e.key === "Enter") {
      if (nameUpdate.trim().length < 3) {
        setError(true);
        return;
      }
      if (e.key === "Enter" && nameUpdate.trim().toLowerCase() === "shared") {
        setUpdateBtnStatus(true);
        showBlockedErrorToast("\"shared\" is a reserved name and cannot be used.");
        return;
      }
      // setShowDeckNameInput(false);
      if (value === "" || nameUpdate === updatedDeckName) {
        return;
      }
      if (updateBtnStatus === true) {
        setUpdateEditable(false);
      }
    }
    if (e.key === "Enter") {
      if (updateBtnStatus === false) {
        updateNameHandler();
      } else {
        setUpdateEditable(false);
      }
    }
  };

  const editName = () => {
    setUpdateEditable(true);
  };

  const linkCreation = () => {
    const link = deckId ? WEB_URL + `pdf-editor/${deckId}` : window.location.href
    return link;
  };

  const copyToClipboard = () => {
    var copyText = document.querySelector("#linkBlock").innerHTML;
    navigator.clipboard.writeText(copyText);
  };

  const otherCountryStatus = ["DRAFT", "NOT SUBMITTED"];
  const spainCountryStatus = [
    "DRAFT",
    "NOT SUBMITTED",
    "REVIEWED WITH MINOR CHANGES",
    "APPROVED WITH MINOR CHANGES",
  ];
  const ValidateStatusCriteria = () => {
    let docstatus = false;
    const isTags = cardInformation?.tags || [];
    const isPdfToHTML = isTags?.includes("PDF_TO_HTML");
    // If the card has the tag "PDF_TO_HTML", we are bypassing the below checks, because it is always editable.
    if (isPdfToHTML) return true;
    const countryOther = countriesList?.find(
      ({ _id, name }) =>
        _id === cardInformation?.market?._id && name !== "Spain"
    );
    const countrySpain =
      countriesList?.find(
        ({ _id, name }) =>
          _id === cardInformation?.market?._id && name === "Spain"
      ) &&
      brands?.find(
        ({ _id, name }) =>
          _id === cardInformation?.brand?._id && name === "Biktarvy"
      );
    if (countryOther) {
      docstatus = otherCountryStatus?.includes(
        cardInformation?.veevaMetadata
          ?.filter((asset) => asset?.assetType === 1)[0]
          ?.docStatus.toUpperCase()
      );
    }
    if (countrySpain) {
      docstatus = spainCountryStatus?.includes(
        cardInformation?.veevaMetadata
          ?.filter((asset) => asset?.assetType === 1)[0]
          ?.docStatus.toUpperCase()
      );
    }

    return docstatus;
  };

  const docLink = cardInformation?.veevaMetadata?.filter(li => li.assetType === 1)[0]?.docLink;
  // const handleClick = () => {
  //   window.open(docLink, '_blank');
  // };

  return (
    <>
      {loading && (
        <CircularProgressBar isloading={loading} setIsloading={setLoading} />
      )}
      <div className="d-flex card-details-informaton">
        <div className="leftInfoSec details-informaton">
          <div className="edetailsRelatedinfo">
            <h2 className="details-informaton-header">
              {templateType === "template"
                ? "Template Information"
                : "e-Detail Information"}
              {cardInformation?.tags?.includes("ONE_TIME_CONTENT") && (
                <span className="details-informaton-header-OTC">One Time Content</span>
              )}
              {cardInformation.expired && (
                <span className="expired-label-details-popup">
                  <span>
                    <img src={expiredRestrictedIcon} />
                    Expired
                  </span>{" "}
                  {convertInDate(
                    cardInformation?.expired_at
                      ? cardInformation?.expired_at
                      : "",
                    "normal"
                  )}
                </span>
              )}
            </h2>
            <div
              className={`d-flex details-content editablefieldInfo ${
                updateEditable ? "alignTextboxInEdit" : ""
              }`}
            >
              {/* <div className='infoFixed-width'>
                                <p className='details-information-name1'>Name</p>
                            </div> */}
              <div className="fix-width details-information-name">Name</div>
              <div class="details-information-link ">
                {mode !== "edit" && (
                  <div
                    className="details-information-content ellipsis-wrap wrapInLine"
                    title={nameUpdate}
                  >
                    {cardInformation?.name ? cardInformation?.name : "-"}
                  </div>
                )}
                {!updateEditable && mode == "edit" && (
                  <>
                    {" "}
                    <img
                      className="editNameIcon"
                      src={EditName}
                      onClick={editName}
                      style={{ cursor: "pointer" }}
                    />{" "}
                    <div
                      title={nameUpdate}
                      className={`details-information-content editCursorPointer ellipsis-wrap wrapInLine`}
                      // onClick={editName}
                    >
                      {nameUpdate ? nameUpdate : "-"}
                    </div>
                  </>
                )}
                {updateEditable && (
                  <TextField
                    type="text"
                    //name="templateName"
                    className="editEdetailName"
                    size="small"
                    variant="outlined"
                    fullWidth={true}
                    inputProps={{ maxLength: 51 }}
                    value={nameUpdate}
                    onChange={(e) => nameChangeHandler(e, "input")}
                    onBlur={(e) => nameChangeHandler(e, "blur")}
                    onKeyDown={(e) => nameChangeHandler(e)}
                    helperText={
                      nameUpdate.trim().length < 3 && error
                        ? "Please use minimum 3 characters"
                        : nameUpdate.trim().toLowerCase() === "shared"
                          ? `"shared" is a reserved name and cannot be used.`
                          : ""
                    }
                    error={nameUpdate.trim().length < 3 || nameUpdate.trim().toLowerCase() === "shared" ? error : ""}
                    autoFocus
                  />
                )}
              </div>
            </div>
            <div className="d-flex details-content">
              <div className="fix-width details-information-name">Product</div>
              <div className="details-information-content">
                {cardInformation?.brand?.name
                  ? cardInformation?.brand?.name
                  : "-"}
              </div>
            </div>
            <div className="d-flex details-content">
              <div className="fix-width details-information-name">
                {templateType === "template" ? "Template" : "e-Detail"} Link
              </div>
              {/* <span className='details-information-content'>https://vcc-builder-qa.indegene.com/editor/641adf0e731233 …</span> */}
              {templateType !== "template" && (
                <div className="">
                  {!cardInformation.expired ? (
                    <div className="details-information-link ">
                      {" "}
                      <img
                        title={copyTitleMsg}
                        src={
                          ValidateStatusCriteria()
                            ? CopyLinkIcon
                            : CopyLinkIconDisable
                        }
                        width={12}
                        height={12}
                        alt=""
                        onClick={() => copyToClipboard()}
                        className={`copyIconforLink ${
                          ValidateStatusCriteria()
                            ? ""
                            : "disablecopyIconforLink"
                        }`}
                      />
                      <div
                        style={{
                          color: `${
                            ValidateStatusCriteria() ? "#203662" : "#707070"
                          }`,
                        }}
                        className={`details-information-content links ${
                          ValidateStatusCriteria() ? "" : "unselectable"
                        }`}
                        id="linkBlock"
                      >
                        {linkCreation()}
                      </div>
                    </div>
                  ) : (
                    <div className={`row details-information-link`}>
                      <div
                        className={`details-information-content ellipsis-wrap unselectable`}
                      >
                        {linkCreation()}
                      </div>
                    </div>
                  )}
                </div>
              )}
              {templateType === "template" && (
                <div className="">
                  {!cardInformation?.locked ? (
                    !cardInformation.expired ? (
                      <div className="details-information-link ">
                        {" "}
                        <img
                          title={copyTitleMsg}
                          src={
                            ValidateStatusCriteria()
                              ? CopyLinkIcon
                              : CopyLinkIconDisable
                          }
                          width={12}
                          height={12}
                          alt=""
                          onClick={() => copyToClipboard()}
                          className={`copyIconforLink ${
                            ValidateStatusCriteria()
                              ? ""
                              : "disablecopyIconforLink"
                          }`}
                        />
                        <div
                          style={{
                            color: `${
                              ValidateStatusCriteria()
                                ? "#203662"
                                : "#707070 !important"
                            }`,
                          }}
                          className={`details-information-content links ${
                            ValidateStatusCriteria() ? "" : "unselectable"
                          }`}
                          id="linkBlock"
                        >
                          {linkCreation()}
                        </div>
                      </div>
                    ) : (
                      <div className={`row details-information-link`}>
                        <div
                          className={`details-information-content ellipsis-wrap unselectable`}
                        >
                          {linkCreation()}
                        </div>
                      </div>
                    )
                  ) : mode === "details" ? (
                    <div className={`row details-information-link`}>
                      <div
                        className={`details-information-content ellipsis-wrap unselectable`}
                      >
                        {linkCreation()}
                      </div>
                      <div className="tempLock">
                        <img
                          src={lockTraceability}
                          width={12}
                          height={12}
                          alt=""
                        />
                        <span className="lockedTempMsg">
                          Template is locked
                        </span>
                      </div>
                    </div>
                  ) : (
                    <div className="details-information-link ">
                      {" "}
                      <img
                        title={copyTitleMsg}
                        src={
                          ValidateStatusCriteria()
                            ? CopyLinkIconDisable
                            : CopyLinkIcon
                        }
                        width={12}
                        height={12}
                        alt=""
                        onClick={() => copyToClipboard()}
                        className={`copyIconforLink ${
                          ValidateStatusCriteria()
                            ? ""
                            : "disablecopyIconforLink"
                        }`}
                      />
                      <div
                        className={`details-information-content links ${
                          ValidateStatusCriteria() ? "" : "unselectable"
                        }`}
                        id="linkBlock"
                      >
                        {linkCreation()}
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
            <div className="d-flex details-content">
              <div className="fix-width details-information-name">Country</div>
              <div className=" details-information-content">
                {cardInformation?.market?.name
                  ? cardInformation?.market?.name
                  : "-"}
              </div>
            </div>
            {/* <div className='d-flex details-content'>
                            <div className='fix-width details-information-name'>Dimension</div>
                            <div className='details-information-content'>{cardInformation?.dimension?.name ? cardInformation?.dimension?.name : '-'}</div>
                        </div>
                        <div className='d-flex details-content'>
                            <div className='fix-width details-information-name'>Device</div>
                            <div className='details-information-content'>{cardInformation?.device?.name ? cardInformation?.device?.name : '-'}</div>
                        </div>
                        <div className='d-flex details-content'>
                            <div className='fix-width details-information-name'>Campaign</div>
                            <div className='details-information-content'>{cardInformation?.campaign?.name ? cardInformation?.campaign?.name : '-'}</div>
                        </div> */}
            <div className="d-flex details-content">
              <div className="fix-width details-information-name">Promomats Doc ID</div>
              <a className="details-information-content hyper-d-link" href={docLink} target="_blank">
                {cardInformation?.veevaMetadata[0]?.docNumber
                  ? cardInformation?.veevaMetadata[0]?.docNumber
                  : "-"}
              </a>
            </div>
            <div className="d-flex details-content">
              <div className="fix-width details-information-name">
                MLR Status
              </div>
              <div className="details-information-content details-information-refresh-page">
                <img
                  src={refreshIcon}
                  alt="image"
                  width={10}
                  height={10}
                  className="details-information-refresh"
                  onClick={() => getCurrentStatus()}
                />
                {latestCardInformation
                  ? latestCardInformation?.docStatus
                    ? latestCardInformation?.docStatus
                    : "Not Submitted"
                  : cardInformation?.veevaMetadata.filter(
                      (asset) => asset.assetType === 1
                    )[0]?.docStatus
                  ? cardInformation?.veevaMetadata.filter(
                      (asset) => asset.assetType === 1
                    )[0]?.docStatus
                  : "Not Submitted"}
              </div>
              {/* <div className='details-information-content'>{cardInformation?.veevaMetadata[0]?.statusMLR ? cardInformation?.veevaMetadata[0]?.statusMLR : 'Not Submitted'}</div> */}
            </div>
            <div className="creation-information">
              <div className="d-flex details-content">
                <div className="fix-width-creation-info details-information-name">
                  Created by
                </div>
                <div className="col-md-8 details-information-content">
                  {cardInformation?.created?.name
                    ? cardInformation?.created?.name
                    : "-"}
                </div>
              </div>
              <div className="d-flex details-content">
                <div className="fix-width-creation-info details-information-name">
                  Created on
                </div>
                <div className="col-md-8 details-information-content">
                  {convertInDate(
                    cardInformation?.created_at
                      ? cardInformation?.created_at
                      : "",
                    "normal"
                  )}
                </div>
              </div>
              <div className="d-flex details-content">
                <div className="fix-width-creation-info details-information-name">
                  Last modified by
                </div>
                <div className="col-md-8 details-information-content">
                  {modifiedBy}
                </div>
              </div>
              <div className="d-flex">
                <div className="fix-width-creation-info details-information-name">
                  Last modified on
                </div>
                <div className="col-md-8 details-information-content">
                  {convertInDate(modifiedOn, "hrs")}
                </div>
              </div>
            </div>
          </div>
        </div>
        
      </div>
      <div className="btnSection">
        <div className="details-informations-footer"></div>
        <button
          className="details-informations-close"
          onClick={closeCardDetailsModal}
        >
          CLOSE
        </button>
        {mode === "edit" && (
          <button
            disabled={updateBtnStatus}
            className="details-informations-update"
            onClick={(e) => updateNameHandler()}
          >
            UPDATE
          </button>
        )}
      </div>
    </>
  );
};

export default PdfDetailsInformationModal;
